import { render, staticRenderFns } from "./PlaceTypes.vue?vue&type=template&id=2468db68&scoped=true&"
import script from "./PlaceTypes.vue?vue&type=script&lang=js&"
export * from "./PlaceTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468db68",
  null
  
)

export default component.exports